import React, {Component} from 'react';

import SubHeading from 'Components/SubHeading';

import {
    TEMPERATURE_UNITS
} from 'Constants/commonConstants';

import Input from 'Components/Input';
import Dropdown from 'Components/Dropdown';

class TemperatureCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            minimum: props.minimum || 0,
            maximum: props.maximum || 0,
            temperatureUnit: props.temperatureUnit || null
        }
    }
    onChange=(e)=> {
        e.stopPropagation();
        this.setState({
            [e.target.name]: e.target.value
        });
    }
    selectTemperatureUnit = (unit)=> {
        this.setState({
            temperatureUnit: unit.value
        })
    }
    stopPropagation=(e)=> {
        e.stopPropagation();
    }
    saveTemperatureDetails = ()=> {
        const { minimum, maximum, temperatureUnit }= this.state;
        this.props.saveTemperatureDetails(minimum, maximum, temperatureUnit);
    }
    render() {
        return (
            <div className="tLeft box-shadow bg-white br-5 pt-15 pl-15 pr-15 z-1 wt-max-content flex flex-column" onClick={this.stopPropagation}>
                <SubHeading text="Temperature" className="mb-10 tLeft"/>
                <div className="flex wt-400 bg-white flex-between">
                    <div className="wt-100">
                        <div className="fSemibold fs-12 caption-color mb-5">Min</div>
                        <Input className="" value={this.state.minimum} name="minimum" onChange={this.onChange}/>
                    </div>
                    <div className="wt-100 ml-20">
                        <div className="fSemibold fs-12 caption-color mb-5">Max</div>
                        <Input className="" value={this.state.maximum} name="maximum" onChange={this.onChange}/>
                    </div>
                    <div className="wt-300 ml-20">
                        <div className="fSemibold fs-12 caption-color mb-5">Unit</div>
                        <Dropdown selectedItem={[...TEMPERATURE_UNITS].find((unitConstant)=> {
                            return this.state.temperatureUnit === unitConstant.value
                        })} 
                        className="flex-1" 
                        items={[...TEMPERATURE_UNITS]} 
                        displayKey="name" 
                        label="Select Temperature Unit" 
                        onSelect={this.selectTemperatureUnit}/>
                    </div>
                </div>
                <button className="bg-theme wt-100 mb-20 ht-30 br-20 fBold fs-14 white-color flex-self-end mt-20" onClick={this.saveTemperatureDetails}> Save</button>
            </div>
        )
    }
}

export default TemperatureCard;
